<template>
  <div id="baggage-return-tab">
    <!--  search form begin  -->
    <div class="form-row">
      <div class="col">
        <label for="baggageTicketId">{{ i18n('Search by baggage ticket id') }}</label>
        <input type="text" id="baggageTicketId" class="form-control" :placeholder="i18n('Search by baggage ticket id')"
               v-model="baggageTicketId"
               @keydown.enter="searchByBaggageTicketId"
        >
      </div>
      <div class="col">
        <label for="passengerTicketId">{{ i18n('Search by passenger ticket id') }}</label>
        <input type="text" id="passengerTicketId" class="form-control" :placeholder="i18n('Search by passenger ticket id')"
               v-model="passengerTicketId"
               @keydown.enter="searchByPassengerTicketId"
        >
      </div>
<!--      <div class="col">-->
<!--        <input type="text" class="form-control" placeholder="search by passenger name"-->
<!--               v-model="passengerName"-->
<!--               @keydown.enter="searchByPassengerName"-->
<!--        >-->
<!--      </div>-->
<!--      <div class="col">-->
<!--        <input type="text" class="form-control" placeholder="search by trip id"-->
<!--               v-model="tripId"-->
<!--               @keydown.enter="searchByTripId"-->
<!--        >-->
<!--      </div>-->
    </div>
    <div class="form-row mt-2">
      <div class="col">
        <button class="btn btn-primary solid_blue waves-effect waves-light"
                @click="searchByBaggageTicketId"
                :disabled="loadingStates.searching"
        >{{ i18n('Search') }}</button>
      </div>
      <div class="col">
        <button class="btn btn-primary solid_blue waves-effect waves-light"
                @click="searchByPassengerTicketId"
                :disabled="loadingStates.searching"
        >{{ i18n('Search') }}</button>
      </div>
    </div>
    <!--  search form end  -->
    <hr>
    <!--    -->
    <div class="row" v-if="baggageFound">
      <div class="col">
        <!--  return types begin  -->
        <div class="form-group form-row">
          <label class="col-lg-3 col-form-label fs-12 pt-12">Вид возврата:</label>
          <div class="col-lg-7">
            <select @change="changeReturnType" class="form-control" v-model="selectedReturnType">
              <option :disabled="true" :selected="true" :value="null">По вине:</option>
              <option :disabled="(howMuchTimeIsLeftBeforeDeparture < 0 && parseInt(key) === 4)"
                      :value="key" v-for="(type, key) in returnTypes">{{ type }}
              </option>
            </select>
          </div>
        </div>
        <!--  return types end  -->
        <!--  Ticket return info begin  -->
        <div v-if="!loadingStates.retrievingTicketReturnInfo" class="form-group form-row">
          <p>{{ i18n('Ticket return info') }}</p>
          <table class="table table-striped table-hover mb-0">
            <thead>
            <tr>
              <th scope="col" v-if="return_type_before_status">Время до ухода рейса</th>
              <th scope="col">Штраф</th>
              <th scope="col">К возврату</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td v-if="return_type_before_status">{{ howMuchTimeIsLeftBeforeDeparture }}</td>
              <td v-if="ticket_fine && return_type_percent">{{ticket_fine + ' сум' + ' (' + return_type_percent
                +'%)'}}
              </td>
              <td v-else>0</td>
              <td v-if="return_price">{{return_price + ' сум'}}</td>
              <td v-else>0</td>
            </tr>
            </tbody>
          </table>
        </div>
        <!--  Ticket return info end  -->
        <!--  Return ticket button begin  -->
        <button
            v-if="baggageFound && !loadingStates.retrievingTicketReturnInfo"
            @click="returnTicket"
            class="btn btn-primary waves-effect waves-light float-right"
            :disabled="(loadingStates.baggageTicketIsReturning || selectedReturnType === null) || !isBaggageAvailableForReturn()"
        >
          <span>Возврат билета</span>
        </button>
        <!--  Return ticket button end  -->

        <!--  Verify by SMS begin  -->
<!--        <div class="form-group form-row col-md-11">-->
<!--          <label class="col-xl-2 col-lg-3 col-form-label fs-12 pt-12">Номер тел для подтверждения:</label>-->
<!--          <div class="col-xl-8 col-lg-7">-->
<!--            <phone-number :disabled="loadingStates.smsSending || smsCodeSent || disableEditPhoneOnReturnTicket"-->
<!--                          class-name="form-control base_input" placeholder="Номер клиента"-->
<!--                          v-model="returningPassengerPhone"></phone-number>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="form-group form-row col-md-11" v-show="smsCodeSent">-->
<!--          <label class="col-xl-2 col-lg-3 col-form-label fs-12 pt-12">Код подтверждения:</label>-->
<!--          <div class="col-xl-8 col-lg-7">-->
<!--            <vue-regex-input :regExp="/^\d{1,6}$/g" class="form-control base_input" v-model="smsCode"></vue-regex-input>-->
<!--          </div>-->
<!--        </div>-->

<!--        <button :disabled="returningPassengerPhone.length !== 9" @click="sendSmsCode"-->
<!--                class="btn base_btn solid_blue waves-effect waves-light float-right size192" type="submit"-->
<!--                v-show="selectedReturnType && !smsCodeSent">-->
<!--          <span aria-hidden="true"-->
<!--                class="spinner-grow spinner-grow-sm text-light" role="status"-->
<!--                v-if="loadingStates.smsSending"></span>-->
<!--          <span v-else>Отправить смс код</span>-->
<!--        </button>-->
        <!--  Verify by SMS end  -->

      </div>
      <div class="col">
        <div class="jumbotron">
          <p class="text-center font-weight-bold">Багажный билет #{{ selectedBaggage.id }}</p>
          <table class="table border-0 table-hover">
            <tr>
              <td>{{ i18n('Trip') }}</td>
              <td>{{ selectedBaggage.trip }} (#{{ selectedBaggage.trip_id }})</td>
            </tr>
            <tr>
              <td>{{ i18n('Baggage weight') }}</td>
              <td>{{ selectedBaggage.baggage_weight }} кг.</td>
            </tr>
            <tr>
              <td>{{ i18n('Departing') }}</td>
              <td>{{ selectedBaggage.departing }}</td>
            </tr>
            <tr>
              <td>{{ i18n('Arriving') }}</td>
              <td>{{ selectedBaggage.arriving }}</td>
            </tr>
            <tr>
              <td>{{ i18n('Departure time') }}</td>
              <td>{{ selectedBaggage.departure_time | moment('YYYY-MM-DD') }}</td>
            </tr>
            <tr>
              <td>{{ i18n('Cashier') }}</td>
              <td>{{ selectedBaggage.cashier }}</td>
            </tr>
            <tr v-show="selectedBaggage.shipping_type === baggageShippingTypes.WITH_PASSENGER">
              <td>{{ i18n('Passenger name') }}</td>
              <td>{{ selectedBaggage.passenger_name }}</td>
            </tr>
            <tr>
              <td>{{ i18n('Sold time') }}</td>
              <td>{{ selectedBaggage.sold_time.date | moment('YYYY-MM-DD') }}</td>
            </tr>
            <tr>
              <td>{{ i18n('Total amount of baggage ticket') }}</td>
              <td>{{ selectedBaggage.total_amount }}</td>
            </tr>
<!--            todo show this label always when validator will work with baggage -->
            <tr v-show="!isBaggageAvailableForReturn()">
              <td>{{ i18n('Status') }}</td>
              <td>{{ selectedBaggage.status_label }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!--    -->
  </div>
</template>

<script>
    export default {
        name: "BaggageReturn",
        components: {},
        data() {
            return {
                baggageTicketId: null,
                passengerTicketId: null,
                passengerName: null,
                tripId: null,
                baggageFound: false,

                selectedBaggage: null,
                selectedReturnType: null,
                returnTypes: null,
                baggageShippingTypes: {
                    WITH_PASSENGER: 1,
                    WITHOUT_PASSENGER: 2,
                },
                loadingStates: {
                    searching: false,
                    returnTypes: false,
                    retrievingTicketReturnInfo: false,
                    baggageTicketIsReturning: false,
                    smsSending: false,
                },

                return_type_percent: '',
                howMuchTimeIsLeftBeforeDeparture: 0,
                return_type_before_status: false,
                ticket_fine: '',
                return_price: '',

                // for SMS verify
                // smsCode: '',
                smsCodeSent: false,
                returningPassengerPhone: '',
                disableEditPhoneOnReturnTicket: true,
            }
        },
        computed: {},
        watch: {},
        created() {
            Object.freeze(this.baggageShippingTypes);
            this.getReturnTypes();
        },
        methods: {
            searchByBaggageTicketId() {
                if (!this.baggageTicketId) {
                    return;
                }
                this.passengerTicketId = null;
                this.baggageFound = false;
                this.loadingStates.searching = true;
                this.$api.get('baggage-return.search-by-baggage-id', {baggage_id: this.baggageTicketId}).then(res => {
                    this.selectedBaggage = res.data;
                    this.howMuchTimeIsLeftBeforeDeparture = res.data.how_much_time_is_left_before_departure;
                    this.returningPassengerPhone = res.data.passenger_phone || '';
                    this.disableEditPhoneOnReturnTicket = this.returningPassengerPhone.length === 9;
                    this.baggageFound = true;
                    if (!_.isEmpty(res.errors)) {
                        this.notifyError(res);
                        return;
                    }
                }).catch(err => {
                    this.notifyError(err.response.data);
                }).finally(() => {
                    this.loadingStates.searching = false;
                });
            },
            searchByPassengerTicketId() {
                if (!this.passengerTicketId) {
                    return;
                }
                this.baggageTicketId = null;
                this.baggageFound = false;
                this.loadingStates.searching = true;
                this.$api.get('baggage-return.search-by-passenger-id', {passenger_id: this.passengerTicketId}).then(res => {
                    this.selectedBaggage = res.data;
                    this.howMuchTimeIsLeftBeforeDeparture = res.data.how_much_time_is_left_before_departure;
                    this.returningPassengerPhone = res.data.passenger_phone || '';
                    this.disableEditPhoneOnReturnTicket = this.returningPassengerPhone.length === 9;
                    this.baggageFound = true;
                    if (!_.isEmpty(res.errors)) {
                        this.notifyError(res);
                        return;
                    }
                }).catch(err => {
                    this.notifyError(err.response.data);
                }).finally(() => {
                    this.loadingStates.searching = false;
                });
            },
            searchByPassengerName() {
                if (!this.passengerName) {
                    return;
                }
            },
            searchByTripId() {
                if (!this.tripId) {
                    return;
                }
            },
            getReturnTypes() {
                this.$api.get('return-ticket.get-return-types').then(({data}) => {
                    this.loadingStates.returnTypes = true;
                    this.returnTypes = data;
                }).finally(() => {
                    this.loadingStates.returnTypes = false;
                });
            },
            changeReturnType() {
                this.loadingStates.retrievingTicketReturnInfo = true;
                this.$api.post('return-ticket.return-price', {
                    type_id: parseInt(this.selectedReturnType),
                    departure_time: new Date(this.selectedBaggage.departure_time).getTime(),
                    current_time: new Date(Date.now()).getTime(),
                    ticket_price: this.selectedBaggage.total_amount,
                }).then(({data}) => {
                    this.return_type_percent = data.percent;
                    this.howMuchTimeIsLeftBeforeDeparture = data.time_before;
                    this.return_type_before_status = (data.before) ? data.before : false;
                    this.ticket_fine = Math.floor((this.selectedBaggage.total_amount / 100) * data.percent);
                    this.return_price = Math.floor(this.selectedBaggage.total_amount - this.ticket_fine);
                }).finally(() => {
                    this.loadingStates.retrievingTicketReturnInfo = false;
                });
            },
            sendSmsCode() {
                this.loadingStates.smsSending = true;
                this.$api.post('return.send-verification-code', {
                    number: this.returningPassengerPhone,
                    passenger_id: this.returningPassengerId,
                    percent: this.return_type_percent
                }).then(res => {
                    this.smsCode = '';
                    if (res.errors) {
                        this.$toast({
                            type: 'error',
                            title: 'SMS не отправлено на (' + this.returningPassengerLongPhone + ')'
                        });
                    } else {
                        this.smsCodeSent = true;
                        this.$toast({
                            type: 'success',
                            title: 'Код подтверждения отправлено на (' + this.returningPassengerLongPhone + ')'
                        });
                    }
                }).catch().finally(() => {
                    this.loadingStates.smsSending = false;
                });
            },
            isBaggageAvailableForReturn() {
                if (!this.selectedBaggage) {
                    return false;
                }
                return this.selectedBaggage.status === 1 || this.selectedBaggage.status === 3;
            },
            returnTicket() {
                this.loadingStates.baggageTicketIsReturning = true;
                this.$api.post('baggage-return.return', {
                    baggage_id: this.selectedBaggage.id,
                    return_type: this.selectedReturnType,
                }).then(res => {
                    if (res.data.success === true) {
                        this.$toast({
                            type: 'success',
                            title: 'Билет был успешно возвращен!'
                        });
                    }
                }).catch(err => {
                    this.notifyError(err.response.data);
                }).finally(() => {
                    this.loadingStates.baggageTicketIsReturning = false;
                    // todo check out this
                    this.searchByBaggageTicketId(this.selectedBaggage.id);
                });
            },
            notifyError(errResponse) {
                let message = errResponse.message;
                if (errResponse.hasOwnProperty('errors')) {
                    for (let error in errResponse.errors) {
                        if (errResponse.errors[error].hasOwnProperty('message')) {
                            message = errResponse.errors[error].message;
                            continue;
                        }
                        if (errResponse.errors.hasOwnProperty(error)) {
                            message += "<br /> - " + errResponse.errors[error];
                        }
                    }
                }
                this.$notify({
                    type: 'error',
                    group: 'foo',
                    title: '',
                    text: message,
                });
            },
        },
    }
</script>
<style scoped>
</style>
